import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-trips-map-dashboard-modal',
  templateUrl: './trips-map-dashboard-modal.component.html',
  styleUrls: ['./trips-map-dashboard-modal.component.css']
})
export class TripsMapDashboardModalComponent implements OnInit {
  @Input() trips: any;
  @Output() onCloseModal = new EventEmitter<any>();

  @ViewChild(GoogleMap) googleMap: GoogleMap;
  latitude = 35.125801;
  longitude = -117.9859038;
  centerLatitude = this.latitude;
  centerLongitude = this.longitude;
  zoom = 18;
  geoCoder: google.maps.Geocoder;
  mapOptions: google.maps.MapOptions = {
    mapTypeId: 'satellite',
    fullscreenControl: true,
    mapTypeControl: true
  };
  address;
  searchedLocation;

  constructor() { }

  ngOnInit() {
    // this.geoCoder = new google.maps.Geocoder;
  }


  onMapReady(map: google.maps.Map) {
    this.updateBounds();
  }

  updateBounds() {
    if (this.googleMap) {
      const bounds = new google.maps.LatLngBounds();
      if (this.searchedLocation) {
        bounds.extend({ lat: this.searchedLocation.latitude, lng: this.searchedLocation.longitude });
      }
      if (this.trips && this.trips.length) {
        this.trips.forEach(trip => {
          bounds.extend({ lat: trip.jobOriginLatitude, lng: trip.jobOriginLongitude });
        });
      }
      if (!bounds.isEmpty()) {
        this.googleMap.fitBounds(bounds);
      }
    }
  }

  onSelectAddress(place) {
    if (place) {
      this.searchedLocation = {
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng()
      }
      this.updateBounds();
    }
    // place.formatted_address
  }


  onCenterChanged() {
    if (this.googleMap) {
      const center = this.googleMap.getCenter();
      if (center) {
        this.centerLatitude = center.lat();
        this.centerLongitude = center.lng();
      }
    }
  }

  setLocation() {
    // this.onCloseModal.emit({
    //   reference: this.reference,
    //   address: this.address,
    //   lat: this.centerLatitude,
    //   lng: this.centerLongitude
    // });
  }


  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results && results.length > 0) {
          this.address = results[0].formatted_address;
        } else {
          sweetAlert('Alert', 'No results found', 'warning', 'Ok')
        }
      } else {
        sweetAlert('Alert', `Geocoder failed due to: ${status}`, 'warning', 'Ok')
      }

    });
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
